import promise1 from "./img/parts/promise1.png";
import promise2 from "./img/parts/promise2.png";
import promise3 from "./img/parts/promise3.png";
import promise4 from "./img/parts/promise4.png";
import freeShippingGrey from "./img/Promisess/Free-shipping-Inactive.jpg";
import freeShippingColored from "./img/Promisess/Free-shipping-Active.jpg";
import expressShippingGrey from "./assets/easy-returns-gray.png";
import expressShippingColored from "./assets/easy-returns-green.png";
import bestPriceGrey from "./img/Promisess/Best-Price-Inactive.jpg";
import bestPriceColored from "./img/Promisess/Best-Price-Active.jpg";
import hourGrey from "./img/Promisess/Resolution-Inactive.jpg";
import hourColored from "./img/Promisess/Resolution-Active.jpg";
import freeDelivery from "./assets/free.png";
import freeReturns from "./img/car-logo.png";
import assistance from "./assets/service-desk.png";
import bestPrice from "./assets/reward.png";
import cratoni from "./assets/cratoni.webp";
import moon from "./assets/moon.webp";
import funn from "./assets/funn.webp";

export const POPULAR_SEARCHES = [
  { label: "Bicycle parts", value: "parts" },
  { label: "Bike accessories", value: "accessories" },
  { label: "Bike maintenance", value: "maintenance" },
  { label: "Bike Lights", value: "lights" },
  { label: "Helmets", value: "helmets" },
  { label: "Cycling Tools", value: "maintenance" },
  { label: "MTB wheelset", value: "wheels" },
  { label: "Cycling Clothes", value: "clothing" },
  { label: "Spare parts", value: "parts" },
  { label: "Best MTB parts", value: "funn" },
  { label: "Mini Tools", value: "granite" },
  { label: "Bicycle gears", value: "drivetrain" },
];

export const SECTIONS = [
  {
    title: "Cockpit",
    items: [
      { label: "Handlebar", value: "handlebar" },
      { label: "Stem", value: "stem" },
      { label: "Seatpost", value: "seatpost" },
      { label: "Grips", value: "grips" },
      { label: "Headset", value: "headset" },
      { label: "Pedal", value: "pedal" },
    ],
  },
  {
    title: "Drivetrain",
    items: [
      { label: "Bottom Bracket", value: "bottom bracket" },
      { label: "Chain", value: "chain" },
      { label: "Crankset", value: "crankset" },
      { label: "Cassette and freely Brake Rotor", value: "cassette" },
      { label: "Derailluer", value: "derailluer" },
      { label: "Shifter", value: "shifter" },
      { label: "Chainring", value: "chainring" },
    ],
  },
  {
    title: "Hydration",
    items: [
      { label: "Bottles", value: "bottles" },
      { label: "Hydration Bags", value: "bags" },
      { label: "Bottle Holders", value: "bottle holders" },
    ],
  },
  {
    title: "Helmets",
    items: [
      { label: "MTB", value: "mtb" },
      { label: "Road", value: "road" },
      { label: "City", value: "city" },
      { label: "Enduro", value: "enduro" },
    ],
  },
  {
    title: "Wheels and Tires",
    items: [
      { label: "wheels", value: "wheel" },
      { label: "Rim", value: "rim" },
      { label: "Hub", value: "hub" },
      { label: "Axles & QR", value: "axles" },
    ],
  },
  {
    title: "Cable and Housing",
    items: [
      { label: "Brake housing", value: "brake housing" },
      { label: "Brake wire", value: "brake wire" },
    ],
  },
  {
    title: "Brakes and Brake Parts",
    items: [
      { label: "Brake Lever", value: "lever" },
      { label: "Disc Brake", value: "disc brake" },
      { label: "Disc Rotor", value: "rotor" },
    ],
  },
  {
    title: "Lights",
    items: [
      { label: "Front Light", value: "front light" },
      { label: "Rear Light", value: "rear light" },
      { label: "Others", value: "light" },
    ],
  },
  {
    title: "Small Parts",
    items: [
      { label: "Chain Guide", value: "chain guide" },
      { label: "Bearing & Spacers", value: "bearing and spacers" },
      { label: "Clamps", value: "clamps" },
    ],
  },
  {
    title: "Pumps & Inflation",
    items: [
      { label: "Air Pump", value: "air pump" },
      { label: "Cartridges", value: "cartridges" },
    ],
  },
  {
    title: "Stands & Storage",
    items: [
      { label: "Stands", value: "stands" },
      { label: "Storage", value: "storage" },
      { label: "Mounts", value: "mounts" },
    ],
  },
  {
    title: "Clothing",
    items: [
      { label: "Cycling Socks", value: "cycling socks" },
      { label: "Tshirts", value: "tshirts" },
    ],
  },
  {
    title: "Sealants & Tubeless Kits",
    items: [
      { label: "Kit & Valves", value: "kit and valves" },
      { label: "Rim Tapes", value: "rim tapes" },
    ],
  },
  {
    title: "Tools",
    items: [{ label: "Mini Tools", value: "mini tools" }],
  },
  {
    title: "Fork",
    items: [{ label: "Suspension Fork", value: "fork" }],
  },
];

export const findqty = (sku_id, qtys) => {
  if (!qtys) {
    return 0; // Return 0 if qtys is null or undefined
  }

  const quantityArray = sku_id?.startsWith("D")
    ? qtys?.CCQuantity
    : qtys?.CCQuantity;

  if (quantityArray) {
    for (const arr of quantityArray) {
      for (const product of arr) {
        if (product?.SKU_ID === sku_id) {
          return product?.qty; // Return the quantity if SKU_ID matches
        }
      }
    }
  }

  return 0; // Return 0 if no matching SKU_ID is found
};

export const shopByCtgData = [
  {
    id: "3",
    category: "Helmets",
    categoryID: "9",
    background:
      cratoni,
    brandLogo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQohbUwx79PkQDbs4YO695jU0OXIAmfqRB-0jAxz05cag&s",
    brandName: "cratoni",
    margin: "30-35",
  },
  {
    id: "4",
    category: "Lights",
    categoryID: "8",
    background:
      moon,
    brandLogo:
      "https://www.handshake.fi/wp-content/uploads/2018/06/logo-moon.png",
    brandName: "moon sports",
    margin: "25-30",
  },
  {
    id: "5",
    category: "Cockpit",
    categoryID: "1",
    background:
      funn,
    brandLogo: "https://images.bike24.com/i/mb/0c/67/20/logofunn-3903.jpg",
    brandName: "funn",
    margin: "25-30",
  },
];

export const findPDPqty = (sku_id, qtys) => {
  if (qtys) {
    for (const arr of qtys) {
      if (arr?.SKU_ID === sku_id) {
        return arr?.qty;
      }
    }
  }

  return 0;
};


export const services = [
  {
    icon: freeDelivery,
    heading: "Free Delivery",
    desc: "Free delivery for purchasing above ₹999",
  },
  {
    icon: bestPrice,
    heading: "Best Price",
    desc: "You are getting the best prices on top-quality products.",
  },
  {
    icon: freeReturns,
    heading: "Hassle Free Returns",
    desc: "Return products effortlessly within days, no questions asked.",
  },
  {
    icon: assistance,
    heading: "24 Hours Issue Resolution",
    desc: "Count on us for swift and efficient resolution within 24 hours.",
  }
];

export const cratoniData = {
  brand: "CRATONI Helmets GmbH",
  description:
    "CRATONI Helmets GmbH is one of the most innovative and biggest safety-helmet manufacturers in the World. The Head Protection specialist Cratoni is a globally active premium brand that has been shaping the market since 1985 with innovative technology and trendy designs. In addition to helmets, CRATONI produces sports glasses. Professional teams like the Ghost Factory Racing Team recognize the outstanding quality of CRATONI and use the products in their competitions. CRATONI has been ensuring that ambitious outdoor, professional, and amateur sportspeople can make the right choice with an innovative range of helmets. Many champions, from Olympic champions to world champions, have relied on the performance of Cratoni helmets.",
  history: {
    foundingYear: 1990,
    focus:
      "Since 1990, CRATONI concentrates on the manufacturing and distribution of bicycle helmets and was the first company in the world to develop the revolutionary HEAD-RING-SYSTEM back in the year 1991, for one helmet size to fit all heads! It is a little known fact that CRATONI originated the helmet retention craze which set a new standard in helmet performance.",
  },
  productDevelopment: {
    collaboration:
      "The know-how of many internationally successful pro-athletes flows into our product development. In close cooperation with professional athletes, CRATONI creates top-class safety helmets regarding design, fit, and safety. This close cooperation with active sportsmen makes revolutionary innovations possible.",
  },
  distribution: {
    agreements:
      "Determined to supply the market with quality products, CRATONI reached exclusive distribution agreements with partners in more than 70 countries worldwide.",
  },
};

export const funnData = {
  brand: "Funn MTB Components",
  slogan: "Elevate Your Ride",
  description:
    "Unleash the Thrill, Master the Trail. Funn Components have been in business since 1997 and have spent the last 20 years helping riders to have more fun on their bikes. Step into a world where precision engineering meets the raw excitement of mountain biking. Born from a passion for pushing the limits on the trail, Funn is dedicated to providing riders with top-tier, high-performance components that redefine what's possible on two wheels.",
  legacy: {
    history:
      "Funn MTB Components has a rich history rooted in the heart of mountain biking. In the early days, Funn components was founded on a passion for World Cup results, best-of-the-best elite racers and shaving nano-seconds off the clock. Athletes like Sam Hill, Brendan Fairclough, Greg Minnaar and hundreds of other greatest-of-all-time heroes of MTB have ridden Funn components.",
  },
  innovation: {
    commitment:
      "Our commitment to innovation is reflected in every component we create. Funn's R&D team tirelessly explores new materials, manufacturing techniques, and design concepts to ensure our products deliver the ultimate in performance and durability. When you ride with Funn, you're riding with the latest advancements in MTB technology.",
  },
  performance: {
    testing:
      "Funn components are not just designed; they are meticulously tested on the trails. We understand the demands of aggressive riding, and that's why our products undergo rigorous testing in real-world conditions. From handlebars to pedals, each component is crafted to withstand the toughest challenges, providing you with confidence and control on every ride.",
  },
  riders: {
    "2023Team": [
      "Matthew Fairbrothers",
      "Brittany Falconer",
      "Eliot Lees",
      "McKenna Meerten",
      "Capella Martin",
      "Elof Lind",
      "Olivier Cuvet",
      "Jakub Vencl",
    ],
    specialties: {
      EnduroRacing: ["Matthew Fairbrothers", "Brittany Falconer"],
      Downhill: ["Eliot Lees", "McKenna Meerten", "Capella Martin"],
      Slopestyle: ["Elof Lind", "Olivier Cuvet", "Jakub Vencl"],
    },
  },
  style: {
    description:
      "Funn MTB Components aren't just about performance; they're also about expressing your unique style on the trail. Our products feature sleek designs and eye-catching graphics, allowing you to stand out while conquering the toughest trails.",
  },
};

export const graniteData = {
  brand: "Granite Design",
  slogan: "Born on the Trails",
  description:
    "Granite Design is a pioneering brand known for its innovative and high-quality cycling accessories and components. With a commitment to excellence and a passion for cycling, Granite Design has become a trusted name among cyclists worldwide. Granite Design is the recipient of various awards for its innovative solutions for cyclists.",
  productLineup: {
    description:
      "Granite Design offers a diverse range of cycling accessories designed to enhance the riding experience and make cycling more enjoyable and convenient for riders of all levels.",
    categories: [
      {
        name: "Bikepacking Essentials",
        description:
          "Essential accessories for bikepacking adventures, ensuring convenience and functionality on the trail.",
      },
      {
        name: "Maintenance Tools",
        description:
          "High-quality tools designed to facilitate bike maintenance and repairs, ensuring optimal performance and longevity of your bike.",
      },
      {
        name: "Other Accessories",
        description:
          "A variety of accessories catering to different needs and preferences, including style, convenience, and functionality.",
      },
    ],
  },
  attributes: {
    innovativeDesign: true,
    durability: true,
    functionality: true,
    versatility: true,
    commitmentToSustainability: true,
  },
  partnership: {
    partner: "CycleCircle",
    description:
      "CycleCircle proudly partners with Granite Design to offer their innovative and high-quality products to our customers.",
  },
};

export const moonData = {
  brand: "Moon-Sports",
  slogan:
    "Where Innovation Meets Adventure in the World of Cycling Illumination",
  description:
    "Moon Sports Lights have been producing lights since 1996, and continue till this day to explore and innovate the industry of bicycle lights, ensuring cyclist can ride at all hours of the day and night. Moon Lights are designed, engineered, developed and produced by passionate cyclists for cyclists. At Moon-Sports, we're not just about creating bicycle lights; we're about crafting an unparalleled cycling experience. Discover a world where cutting-edge technology meets sleek design, ensuring you ride with confidence, day or night.",
  innovation: {
    description:
      "Stay ahead of the curve by integrating the latest LED and battery technologies into Moon-Sports lights. Experience unmatched brightness, extended battery life, and consistent performance on every ride.",
  },
  design: {
    description:
      "Elevate your bike's aesthetics with Moon lights. Our design team ensures that every product not only enhances your visibility but also complements your bike's style seamlessly.",
  },
  safety: {
    description:
      "Rider’s safety is Moon lights top priority. Our lights undergo rigorous testing to meet and exceed industry standards, providing you with the confidence to ride any time, anywhere.",
  },
  versatility: {
    description:
      "Whether you're a daily commuter, a weekend warrior, or a thrill-seeking off-road enthusiast, Moon-Sports has the perfect lighting solution for you. Explore our range and find the ideal companion for your cycling adventures.",
  },
  sustainability: {
    description:
      "At Moon-Sports, we're committed to preserving the environment. Our manufacturing processes prioritize sustainability, using eco-friendly materials and energy-efficient technologies to minimize our impact on the planet.",
  },
};

export const shimanoData = {
  brand: "Shimano",
  slogan: "Precision Engineered for Every Ride",
  description:
    "Founded in 1921 in Sakai, Japan, Shimano is a global leader in bicycle components, fishing tackle, and rowing equipment. In cycling, Shimano is renowned for its precision engineering, durability, and innovation. From elite WorldTour racing groupsets to dependable commuter components, Shimano products are trusted by riders across road, mountain, gravel, and urban cycling disciplines worldwide.",
  innovation: {
    description:
      "Shimano continuously pioneers drivetrain and braking technologies such as Di2 electronic shifting, Hyperglide+ gear systems, and advanced hydraulic disc brakes. Their commitment to research and development ensures smoother shifting, efficient power transfer, and reliable performance in all riding conditions.",
  },
  performance: {
    description:
      "From the flagship DURA-ACE road groupset to the rugged DEORE XT mountain lineup, Shimano components are engineered for lightweight strength, precision control, and long-term durability. Professional athletes and enthusiasts alike rely on Shimano for consistent performance.",
  },
  safety: {
    description:
      "Shimano integrates advanced braking systems, including hydraulic disc and ICE TECHNOLOGIES cooling solutions, delivering powerful, controlled stopping performance. Safety, reliability, and rider confidence remain central to Shimano’s engineering philosophy.",
  },
  versatility: {
    description:
      "Shimano offers solutions for road cycling, MTB, gravel, touring, e-bikes, and city commuting. Whether you're racing competitively or enjoying a weekend ride, Shimano provides a complete ecosystem of components designed to work seamlessly together.",
  },
  sustainability: {
    description:
      "Shimano is committed to sustainable manufacturing and environmental responsibility, focusing on reducing carbon emissions, improving energy efficiency, and supporting cycling as a sustainable mode of transportation worldwide.",
  },
};


export const coloredImages = {
  freeShipping: freeShippingColored,
  expressShipping: expressShippingColored,
  bestPrice: bestPriceColored,
  hour: hourColored,
};

export const greyImages = {
  freeShipping: freeShippingGrey,
  expressShipping: expressShippingGrey,
  bestPrice: bestPriceGrey,
  hour: hourGrey,
};

export const dummyData = [
  {
    imgSrc: promise1,
    title: "Free shipping",
    description: "We provide you Free Delivery above ₹999.",
    coloredImage: coloredImages.freeShipping,
    greyImage: greyImages.freeShipping,
  },
  {
    imgSrc: promise3,
    title: "Best price",
    description: "You are getting the best prices on top-quality products.",
    coloredImage: coloredImages.bestPrice,
    greyImage: greyImages.bestPrice,
  },
  {
    imgSrc: promise4,
    title: "24 Hours Issue resolution",
    description:
      "Count on us for swift and efficient resolution within 24 hours.",
    coloredImage: coloredImages.hour,
    greyImage: greyImages.hour,
  },
  {
    imgSrc: promise2,
    title: "Easy Returns",
    description: "Return products effortlessly within days, no questions asked.",
    coloredImage: coloredImages.expressShipping,
    greyImage: greyImages.expressShipping,
  },
];

export const promisesData = [
  {
    greyImage: freeShippingGrey,
    coloredImage: freeShippingColored,
  },
  {
    greyImage: expressShippingGrey,
    coloredImage: expressShippingColored,
  },
  {
    greyImage: bestPriceGrey,
    coloredImage: bestPriceColored,
  },
  {
    greyImage: hourGrey,
    coloredImage: hourColored,
  },
];
